module.exports={
   "S1": ["s", "m", "g"],
   "S2": ["s", "m", "g"],
   "S3": ["s", "m", "g"]
}